// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import traceLinkEntity from './entities/trace-link.json';
import traceLinkMenu from '../pages/trace-link/menu.json';
import traceLinkFullForm from '../pages/trace-link/forms/full.json';
import traceLinkContextForm from '../pages/trace-link/forms/context.json';
import traceLinkMiniForm from '../pages/trace-link/forms/mini.json';
import traceLinkLookupForm from '../pages/trace-link/forms/lookup.json';
import traceLinkTableView from '../pages/trace-link/views/table.json';
import traceLinkCardsView from '../pages/trace-link/views/cards.json';
import traceLinkDashboardView from '../pages/trace-link/views/dashboard.json';

/** Тип запису «Зв’язок простежуваності» зі сторінками пакета: меню, форми та подання з pages/trace-link/. */
export const traceLinkDefinition: IRecordTypeDefinition = {
  ...traceLinkEntity,
  views: assembleViewSet({
      table: traceLinkTableView,
      cards: traceLinkCardsView,
      dashboard: traceLinkDashboardView,
  }),
  form: traceLinkFullForm,
  forms: { full: traceLinkFullForm, context: traceLinkContextForm, mini: traceLinkMiniForm, lookup: traceLinkLookupForm },
  menu: traceLinkMenu,
} as IRecordTypeDefinition;
